const formatPrice = (price, wcSettings, decimalSeparator = ",") => {
    const { woocommerceCurrency, woocommerceCurrencyPos, woocommercePriceDisplaySuffix, woocommercePriceNumDecimals, woocommercePriceThousandSep, } = wcSettings;
    const symbols = {
        EUR: "€",
        GBP: "£",
        USD: "$",
        COP: "$",
    };
    let formattedPrice = "";
    const NumDecimals = parseInt(woocommercePriceNumDecimals || 0);
    formattedPrice = price.toFixed(NumDecimals);
    formattedPrice = formattedPrice
        .split(".")
        .map((e, i) => {
        if (i > 0) {
            return e;
        }
        return e
            .split("")
            .reverse()
            .map((digit, index) => {
            if (index % 3 === 2) {
                return woocommercePriceThousandSep + digit;
            }
            return digit;
        })
            .reverse()
            .join("")
            .trim();
    })
        .join(decimalSeparator);
    const symbol = symbols[woocommerceCurrency] || woocommerceCurrency;
    if (woocommerceCurrencyPos === "right_space") {
        /* à améliorer. quelles sont les autres valeurs possibles ? */
        formattedPrice = formattedPrice + "\xa0" + symbol;
    }
    else {
        formattedPrice = symbol + formattedPrice;
    }
    formattedPrice += woocommercePriceDisplaySuffix;
    return formattedPrice;
};
export default formatPrice;
